// @ts-ignore
import { pathOr } from 'ramda';

let errorHandling= {
  install(Vue: any, options: any) {
    const vm = Vue.prototype;
    const generateError =(error:any) => {
      const status = pathOr(null, ['response', 'status'], error)
      if(!status || status === 401) return;

      const errorMessage = pathOr(null, ["data", "data", "error"], error.response);
      if (errorMessage === "invalid_credentials") {
        return vm.$notify.error(vm.$lang.error_message_login);
      }

      let messages = [];
      if (status === 422) {
        const errors = pathOr(null, ['response', 'data', 'errors'], error);
        const errorsKeys = Object.keys(errors);
        for (const key of errorsKeys) {
           const newErrors = errors[key];
            messages = [...newErrors]
        }
      } else {
        messages = pathOr([], ['response', 'data', 'message'], error);
      }

      if(Array.isArray(messages)){
          messages.forEach((message: any) => vm.$notify.error(message));
      } else {
        vm.$notify.error(messages);
      }
    }
    vm.$generateError=generateError
  }
}

export default errorHandling;
